import { KYMW2100Model } from '../kymw2100.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';

/**
 * 媒体情報を取得するサービス
 *
 * @export GetCatalogProgressOfMediumService
 * @class GetCatalogProgressOfMediumService
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetCatalogProgressOfMediumService extends PlessJsonResponderSub<any> {

  vo = {
    OrderCode: '',
  };

  private model: KYMW2100Model;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetCatalogProgressOfMediumService
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
        OrderCode: this.vo.OrderCode
      }
    });
  }

  /**
   * API呼び出し
   *
   * @param model
   * @memberof GetCatalogProgressOfMediumService
   */
  execute(model: KYMW2100Model, vo: any): void {
    this.model = model;
    this.vo = vo;
    this.send('getCatalogProgressOfMedium', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetCatalogProgressOfMediumService
   */
  success(data: any): void {
    if (data !== null) {
      // 媒体、フェーズの一覧を更新する
      this.model.updateMediumTypeList(data);
      this.model.kymw2100Component.txt_OrderCode.setFocus();
    }
  }
}
